import React, { FC, SyntheticEvent } from 'react'
import { RouteComponentProps } from '@reach/router'
import { InputGroup } from '@blueprintjs/core'
import { Flex, Icon } from '@ui'
import { CurrentBookingsTable } from '../CurrentBookingsTable'
import useBookingsData, { UseBookingsHook } from './hooks/useBookingsData'
import createBookingColumns from './createColumns'
import css from './bookingsTeamsTab.module.scss'
import api from '@api'
import { TodayFilter } from './components/TodayFilter'
import { BaseTableFilters } from '../CurrentBookingsTable/types'
import { TodayFilterValues } from './types'
import { DateUtil } from '../../utils/dateUtil'
import { DatesFilter } from './components/DatesFilter'

const BookingsTeamsTab: FC<React.PropsWithChildren<RouteComponentProps>> = ({ navigate }) => {
  const bookingsDataHook = useBookingsData()

  const columns = createBookingColumns({
    cancelBooking: (bookingId) => {
      bookingId && api.booking.cancel.bookings({ bookingIds: [bookingId] })
    },
  })

  //handlers
  const handleSearch = (e: SyntheticEvent<HTMLInputElement>) => {
    bookingsDataHook.updateFilters({
      query: e.currentTarget.value.toLowerCase(),
    })
  }

  const handleTodayFilter = (val: TodayFilterValues) => {
    bookingsDataHook.updateFilters(dateFilterMap[val])
  }

  const handleClearDateFilter = () => {
    bookingsDataHook.updateFilters({ fromDate: null, toDate: null })
  }

  const handleSelectDateFilter = (fromDate: Date, toDate: Date) => {
    bookingsDataHook.updateFilters({
      fromDate,
      toDate,
    })
  }

  return (
    <div className={css.wrapper}>
      <Flex className={css.header} align="center">
        <TodayFilter onChange={handleTodayFilter} />
        <Flex align="center" className={css.header_right}>
          {bookingsDataHook.filters.fromDate && bookingsDataHook.filters.toDate && (
            <Flex align="center" className={css.delete_filter}>
              {DateUtil(bookingsDataHook.filters.fromDate).format(DATE_FORMAT)} -{' '}
              {DateUtil(bookingsDataHook.filters.toDate).format(DATE_FORMAT)}{' '}
              <div className={css.delete_filter_button} onClick={handleClearDateFilter}>
                <Icon name="xmark" />
              </div>
            </Flex>
          )}
          <DatesFilter
            minDate={bookingsDataHook.fromDate}
            maxDate={bookingsDataHook.toDate}
            toDate={bookingsDataHook.filters.toDate}
            fromDate={bookingsDataHook.filters.fromDate}
            onClickClear={handleClearDateFilter}
            onSelectDay={handleSelectDateFilter}
          />

          <InputGroup
            className={css.search_box}
            fill
            placeholder="Find"
            onChange={handleSearch}
            rightElement={<Icon name="search" />}
          />
        </Flex>
      </Flex>
      <CurrentBookingsTable<BaseTableFilters, UseBookingsHook>
        headerTopWithoutFilter={0}
        columns={columns}
        bookingHook={bookingsDataHook}
      />
    </div>
  )
}

export default BookingsTeamsTab

const dateFilterMap = {
  [TodayFilterValues.ALL_BOOKINGS]: {
    toDate: null,
    fromDate: null,
  },
  [TodayFilterValues.TODAY]: {
    fromDate: DateUtil().startOfDayToDate().toDate(),
    toDate: DateUtil().endOfDayToDate().toDate(),
  },
}

const DATE_FORMAT = 'MMM dd, yyyy'
